<div class="font24 p-5 mt-5 text-blue-lighter justify-content-center align-items-center">
    Welcome to Admin Portal of e-Store.
    <hr>
    Kindly Navigae to Menu Option to Perform Tasks such as Add/Edit/Delete Users, Products and Configure System Details.
</div>